<template>
  <div>
    <ts-page-title
      :title="$t('dailyAttendances.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('dailyAttendances.pageTitle'),
          active: true
        }
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper>
        <div class="row">
          <div class="col-md-2 form-group ts-px-2">
            <label class="form-col-label control-label required ts-mb-2">{{
              $t('dailyAttendances.date')
            }}</label>
            <DatePicker
              class="ts-w-full"
              :value="date"
              @on-change="onChange"
              format="dd-MM-yyyy"
              type="date"
              :class="{
                'ivu-form-item-error': errors.has('date')
              }"
            />
            <div
              class="ivu-form-item-error ts-text-red-600"
              v-if="errors.has('date')"
            >
              {{ errors.first('date') }}
            </div>
          </div>
          <div class="col-md-2 form-group ts-px-2">
            <label class="form-col-label control-label required ts-mb-2">{{
              $t('dailyAttendances.organisationalStructure')
            }}</label>
            <Select
              v-model="org_chart_structure_id"
              clearable
              :class="{
                'ivu-form-item-error': errors.has('org_chart_structure_id')
              }"
            >
              <Option
                v-for="(orgChartStructure, index) in orgChartStructures"
                :key="index"
                :value="orgChartStructure.org_chart_structure_id"
                >{{ orgChartStructure.org_chart_structure }}
              </Option>
            </Select>
            <div
              class="ivu-form-item-error ts-text-red-600"
              v-if="errors.has('org_chart_structure_id')"
            >
              {{ errors.first('org_chart_structure_id') }}
            </div>
          </div>
          <div class="col-md-2 form-group ts-px-2">
            <label class="form-col-label control-label ts-mb-2">{{
              $t('dailyAttendances.status')
            }}</label>
            <Select v-model="status">
              <Option value="All" selected>All</Option>
              <Option value="Present">Present</Option>
              <Option value="Absent">Absent</Option>
              <Option value="Take Leave">Take Leave</Option>
            </Select>
          </div>
          <div class="col-md-2 form-group ts-px-2 ts-pt-6">
            <Button class="ts-mb-1" type="info" ghost @click="fetchData"
              >{{ $t('search') }}
            </Button>
          </div>
        </div>
      </ts-panel-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        :loading="loading"
        max-height="700"
        highlight-row
        stripe
        border
      >
        <template slot-scope="{ row }" slot="total_hour1">
          <strong>{{ row.total_hour1 }}</strong>
        </template>
        <template slot-scope="{ row }" slot="total_hour2">
          <strong>{{ row.total_hour2 }}</strong>
        </template>
        <template slot-scope="{ row }" slot="total_hour3">
          <strong>{{ row.total_hour3 }}</strong>
        </template>
        <template slot-scope="{ row }" slot="total_hour4">
          <strong>{{ row.total_hour4 }}</strong>
        </template>
      </Table>
      <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
        <ts-i-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-i-pagination>
      </div>
    </ts-panel>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'daily-attendanceIndex',
  components: {},
  data () {
    return {
      date: moment(new Date()).format('DD-MM-YYYY'),
      errors: new Errors(),
      loading: false,
      org_chart_structure_id: null,
      status: 'All',
      data: null
    }
  },
  computed: {
    ...mapState('humanResource/dailyAttendance', [
      'resources',
      'pagination',
      'orgChartStructures'
    ]),
    columns () {
      return [
        {
          title: this.$t('dailyAttendances.cardNumber'),
          key: 'card_id',
          minWidth: 150
        },
        {
          title: this.$t('dailyAttendances.employeeName'),
          key: 'employee_name_en',
          minWidth: 200
        },
        {
          title: this.$t('dailyAttendances.shift'),
          key: 'shift_name',
          minWidth: 150
        },
        {
          title: this.$t('dailyAttendances.position'),
          key: 'position',
          minWidth: 250
        },
        {
          title: this.$t('dailyAttendances.t1'),
          align: 'center',
          children: [
            {
              title: this.$t('dailyAttendances.checkIn'),
              align: 'center',
              key: 't1',
              width: 100
            },
            {
              title: this.$t('dailyAttendances.checkOut'),
              align: 'center',
              key: 't2',
              width: 100
            }
          ]
        },
        {
          title: this.$t('dailyAttendances.total1'),
          slot: 'total_hour1',
          align: 'center',
          width: 100
        },
        {
          title: this.$t('dailyAttendances.t2'),
          align: 'center',
          children: [
            {
              title: this.$t('dailyAttendances.checkIn'),
              align: 'center',
              key: 't3',
              width: 100
            },
            {
              title: this.$t('dailyAttendances.checkOut'),
              align: 'center',
              key: 't4',
              width: 100
            }
          ]
        },
        {
          title: this.$t('dailyAttendances.total2'),
          slot: 'total_hour2',
          align: 'center',
          width: 100
        },
        {
          title: this.$t('dailyAttendances.t3'),
          align: 'center',
          children: [
            {
              title: this.$t('dailyAttendances.checkIn'),
              align: 'center',
              key: 't5',
              width: 100
            },
            {
              title: this.$t('dailyAttendances.checkOut'),
              align: 'center',
              key: 't6',
              width: 100
            }
          ]
        },
        {
          title: this.$t('dailyAttendances.total3'),
          slot: 'total_hour3',
          align: 'center',
          width: 100
        },
        {
          title: this.$t('dailyAttendances.t4'),
          align: 'center',
          children: [
            {
              title: this.$t('dailyAttendances.checkIn'),
              align: 'center',
              key: 't7',
              width: 100
            },
            {
              title: this.$t('dailyAttendances.checkOut'),
              align: 'center',
              key: 't8',
              width: 100
            }
          ]
        },
        {
          title: this.$t('dailyAttendances.total4'),
          slot: 'total_hour4',
          align: 'center',
          width: 100
        }
      ]
    }
  },
  methods: {
    ...mapActions('humanResource/dailyAttendance', ['getOrgChartStructure']),
    async fetchResource () {
      this.loading = true
      await this.getOrgChartStructure()
      this.loading = false
    },
    onChange (data) {
      this.date = data
    },
    async fetchData (attributes) {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch('humanResource/dailyAttendance/fetch', {
          date: this.date,
          org_chart_structure_id: this.org_chart_structure_id,
          status: this.status,
          ...attributes
        })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
    },
    notice (not) {
      this.$Notice[not.type]({
        title: 'DAILY ATTENDANCES',
        desc: not.text
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('humanResource/dailyAttendance/RESET_STATE')
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchResource()
    })
  }
}
</script>
